import Vue from "vue";
import Head from "vue-head";
import VueRouter from "vue-router";

// import Home from "../views/Home.vue";
// import Mortgage from "../views/Mortgage.vue";
// import Refinance from "../views/Refinance.vue";
import store from "../store";

Vue.use(VueRouter);

Vue.use(Head, {
   complement: "APPLIACTION TITLE",
});

const routes = [
   // {
   //    path: "/",
   //    name: "Home",
   //    component: Home,
   //    meta: {
   //       h1: "Home",
   //       title: "Home Page - Example App",
   //       metaTags: [
   //          {
   //             name: "description",
   //             content: "The home page of our example app.",
   //          },
   //          {
   //             property: "og:description",
   //             content: "The home page of our example app.",
   //          },
   //       ],
   //    },
   // },
   // {
   //    path: "/about",
   //    name: "About",
   //    // route level code-splitting
   //    // this generates a separate chunk (about.[hash].js) for this route
   //    // which is lazy-loaded when the route is visited.
   //    component: () =>
   //       import(/* webpackChunkName: "about" */ "../views/About.vue"),
   //    meta: {
   //       h1: "About",
   //       title: "About Page - Example App",
   //       metaTags: [
   //          {
   //             name: "description",
   //             content: "The about page of our example app.",
   //          },
   //          {
   //             property: "og:description",
   //             content: "The about page of our example app.",
   //          },
   //       ],
   //    },
   // },
   {
      path: "/signin",
      name: "SignIn",
      component: () =>
         import(/* webpackChunkName: "mortgage-page" */ "../views/SignIn.vue"),
      meta: {
         h1: "Sign In",
         title: "Sign In Page",
         metaTags: [
            {
               name: "description",
               content: "The about the sign in page of this example app.",
            },
            {
               property: "og:description",
               content: "The sign in page of this example app.",
            },
         ],
      },
   },
   {
      path: "/signout",
      name: "SignOut",
      component: () =>
         import(/* webpackChunkName: "mortgage-page" */ "../views/SignOut.vue"),
      meta: {
         h1: "Signed Out",
         title: "Sign Out",
         metaTags: [
            {
               name: "description",
               content: "The about the sign out page of this example app.",
            },
            {
               property: "og:description",
               content: "The sign out page of this example app.",
            },
         ],
      },
   },
   { path: "/", redirect: "/signin" },
   {
      path: "/mortgage",
      alias: "/mortgage/es",
      name: "Mortage",
      component: () =>
         import(
            /* webpackChunkName: "mortgage-page" */ "../views/Mortgage.vue"
         ),
      meta: {
         h1: "Mortgage",
         title: "Mortgage Page - Example App",
         requiresAuth: true,
         metaTags: [
            {
               name: "description",
               content: "The about the mortgage page of this example app.",
            },
            {
               property: "og:description",
               content: "The mortgage page of this example app.",
            },
         ],
      },
   },
   {
      path: "/refinance",
      alias: "/refinance/es",
      name: "Refinance",
      component: () =>
         import(
            /* webpackChunkName: "refinance-page" */ "../views/Refinance.vue"
         ),
      meta: {
         h1: "Refinance",
         title: "Refinance Page - Example App",
         requiresAuth: true,
         metaTags: [
            {
               name: "description",
               content: "The about the refinance page of this example app.",
            },
            {
               property: "og:description",
               content: "The refinance page of this example app.",
            },
         ],
      },
   },
   {
      path: "/home-equity",
      alias: "/home-equity/es",
      name: "HomeEquity",
      component: () =>
         import(
            /* webpackChunkName: "home-equity-page" */ "../views/HomeEquity.vue"
         ),
      meta: {
         h1: "Home Equity",
         title: "Home Equity Page - Example App",
         requiresAuth: true,
         metaTags: [
            {
               name: "description",
               content: "The about the home equity page of this example app.",
            },
            {
               property: "og:description",
               content: "The home equity page of this example app.",
            },
         ],
      },
   },
];

const router = new VueRouter({
   routes,
   scrollBehavior(to, from, savedPosition) {
      // let position = { x: 0, y: 0 };
      // // Keep scroll position when using browser buttons
      // if (savedPosition) {
      //    position = savedPosition;
      // }

      // // Workaround for transitions scrolling to the top of the page
      // // However, there are still some problems being fixed by the vue team
      // return new Promise((resolve, reject) => {
      //    setTimeout(() => {
      //       resolve(position);
      //    }, 500);
      // });
      if (savedPosition) {
         // Keep scroll position when using browser buttons
         return savedPosition;
      } else {
         return { x: 0, y: 0 };
      }
   },
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
   const isAuthorized = store.getters["auth/isSignedIn"];

   // Redirect user back to mortgage page is attempted to visit the signin page

   if (isAuthorized && to.path === "/signin") {
      next("/mortgage");
      return;
   }

   // Set current page in store
   store.commit("page/setPage", to.meta);

   const locale = to.path.endsWith(`/es`) ? "es" : "en";

   if (locale !== store.state.locale.locale) {
      store.commit("locale/setLocale", locale);
      console.log("changed locale ~~~~~~~~~", locale);
   }

   // This goes through the matched routes from last to first, finding the closest route with a title.
   // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
   const nearestWithTitle = to.matched
      .slice()
      .reverse()
      .find((r) => r.meta && r.meta.title);

   // Find the nearest route element with meta tags.
   const nearestWithMeta = to.matched
      .slice()
      .reverse()
      .find((r) => r.meta && r.meta.metaTags);
   const previousNearestWithMeta = from.matched
      .slice()
      .reverse()
      .find((r) => r.meta && r.meta.metaTags);

   if (
      nearestWithMeta &&
      nearestWithMeta.meta &&
      nearestWithMeta.meta.requiresAuth
   ) {
      if (isAuthorized) {
         next();
         return;
      } else {
         next("/signin");
      }
   } else {
      // console.log("~~~~~ failed nearestWithMeta check ", to, nearestWithMeta);
   }

   // If a route with a title was found, set the document (page) title to that value.
   if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

   // Remove any stale meta tags from the document using the key attribute we set below.
   Array.from(
      document.querySelectorAll("[data-vue-router-controlled]")
   ).map((el) => el.parentNode.removeChild(el));

   // Skip rendering meta tags if there are none.
   if (!nearestWithMeta) return next();

   // Turn the meta tag definitions into actual elements in the head.
   nearestWithMeta.meta.metaTags
      .map((tagDef) => {
         const tag = document.createElement("meta");

         Object.keys(tagDef).forEach((key) => {
            tag.setAttribute(key, tagDef[key]);
         });

         // We use this to track which meta tags we create, so we don't interfere with other ones.
         tag.setAttribute("data-vue-router-controlled", "");

         return tag;
      })
      // Add the meta tags to the document head.
      .forEach((tag) => document.head.appendChild(tag));

   next();
});

export default router;
